export default function({ dispatch, commit }, params) {
    commit('startedAuthentication')

    // POST /auth/change/email
    return dispatch('post', {
        url: '/provider/auth/password',
        data: params
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        return response
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
